import { ThreeElements } from '@react-three/fiber'
import { useTexture } from "@react-three/drei"
import vignetteAlpha from "./assets/vignette-alpha.png"

interface Props {
  url: string;
  zoom?: number;
  vignette?: boolean;
  opacity?: number;
  fullBright?: boolean;
}

/**
 * This component should be wrapped in <Suspense></Suspense>
 * Can't do that internally for some reason.
 */
function ImagePlane(props: Props & ThreeElements['mesh']) {
  const colorMap = useTexture(props.url);
  const vignetteTexture = useTexture(vignetteAlpha);
  const zoom = props.zoom || 1;
  colorMap.repeat.x = 1 / zoom;
  colorMap.repeat.y = 1 / zoom;
  // When zoom is 1, offset should be 0
  // When zoom is 2, offset should be .25
  // When zoom is 3, offset should be .33
  // When zoom is 4, offset should be > .25


  colorMap.offset.x = (zoom - 1) / (2 * zoom); // 0, .5, 1, 1.5
  colorMap.offset.y = (zoom - 1) / (2 * zoom);

  const alphaMap = props.vignette ? vignetteTexture : undefined;

  return (
    <mesh {...props}>
      <planeGeometry args={[1, 1]} />
      {/*Setting toneMapped to false ensures the image is displayed as-is. For example if it has*/}
      {/*a white background, it will be fully white, and the image will have full contrast.*/}
      {/*This seems appropriate for a product image.*/}
      <meshBasicMaterial map={colorMap} toneMapped={!props.fullBright} alphaMap={alphaMap} transparent={true} opacity={props.opacity}/>
    </mesh>
  )
}

export default ImagePlane;
